import { render, staticRenderFns } from "./ik-word-editor.vue?vue&type=template&id=19ac3fb3&scoped=true&"
import script from "./ik-word-editor.vue?vue&type=script&lang=js&"
export * from "./ik-word-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ac3fb3",
  null
  
)

export default component.exports